import Text from "_shared/text/text";

export default class FeeScheduleCategoryName extends Text {
  public isEqualTo = (other: Text): boolean => 
    other instanceof FeeScheduleCategoryName
    && super.isEqualTo(other);
  
  public static override fromJSON(value: string | number | boolean | object | null | undefined): FeeScheduleCategoryName | null | undefined{
    if (value === null || value === undefined)
      return value;
    if (typeof value !== 'string')
      throw new Error('Cannot create FeeScheduleCategoryName from non-string value');
    return new FeeScheduleCategoryName(value);
  }
}
